import React, { useEffect, useState } from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody } from '../../components/ui/Table';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';

export const APILogDashboard: React.FC = () => {
  const [logs, setLogs] = useState<any[]>([]);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    fetch('/api/billing/api-traces?limit=100')
      .then(res => res.json())
      .then(setLogs);
  }, []);

  const filteredLogs = logs.filter(log =>
    !filter ||
    log.traceId?.includes(filter) ||
    log.campaignId?.includes(filter) ||
    log.userId?.includes(filter) ||
    log.status?.includes(filter)
  );

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">API Log Dashboard</h1>
      <Input
        placeholder="Filter by trace ID, campaign, user, or status"
        value={filter}
        onChange={e => setFilter(e.target.value)}
        className="mb-4"
      />
      <div className="overflow-x-auto">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Trace ID</TableCell>
              <TableCell>Campaign</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Step</TableCell>
              <TableCell>Prompt</TableCell>
              <TableCell>Response</TableCell>
              <TableCell>Cost</TableCell>
              <TableCell>Duration (ms)</TableCell>
              <TableCell>Created</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredLogs.map(log => (
              <TableRow key={log.id}>
                <TableCell>{log.traceId}</TableCell>
                <TableCell>{log.campaignId}</TableCell>
                <TableCell>{log.userId}</TableCell>
                <TableCell><Badge>{log.status}</Badge></TableCell>
                <TableCell>{log.step}</TableCell>
                <TableCell className="max-w-xs truncate"><span title={log.prompt}>{log.prompt?.slice(0, 60)}</span></TableCell>
                <TableCell className="max-w-xs truncate"><span title={log.response}>{log.response?.slice(0, 60)}</span></TableCell>
                <TableCell>{log.cost}</TableCell>
                <TableCell>{log.durationMs}</TableCell>
                <TableCell>{new Date(log.createdAt).toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}; 